import getActions from "./actionsPopupUtils";

const employer_actions = (formName, isSubaccount) => {
  return getActions({
    formName,
    isSubaccount,
    shared: false,
    subNoun: "point-of-contact profiles",
    mainNoun: "employer",
  });
};

export default employer_actions;
